export default __webpack_public_path__ + "static/media/pexels-burst-374140.e253637f.jpg";